export default "__VITE_ASSET__C8rILav3__"